exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ast-view{overflow-y:auto}.ast-view .node rect{cursor:pointer;fill:#fff;fill-opacity:.9;stroke:#000;stroke-width:1.5px}.ast-view .node text{font:11px sans-serif;font-weight:700;pointer-events:none;fill:#fff}.ast-view path.link{fill:none;stroke:#9ecae1;stroke-width:1.5px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/app/tabs/v2/astView.less
 ** module id = 181
 ** module chunks = 0
 **/